module.exports = __webpack_public_path__ + "img/pleisure_bodyimage04.c90e0172.jpg";